import React, { useState, useEffect } from 'react';
import { makeStyles, Button, TextField } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { Formik, Form } from 'formik';
import { FormikTextField } from 'formik-material-fields';
import * as Yup from 'yup';
import GreenButton from '../../Shared/GreenButton';
import {
    DatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { IconButton, InputAdornment } from "@material-ui/core";
import {fromNewDateFormatToYYYYMMDD} from '../../../Helpers/dateHelper'
import { generateNewId } from '../../../Helpers/generalHelper';

export default function CreateClosingDayDrawer(props) {
    const classes = useStyles();
    const [start, setStart] = useState(null)
    const [description, setDescription] = useState(null)

    function startDateChanged(date) {
        setStart(date)
    }

    function descriptionChanged(e) {
        setDescription(e.target.value)
    }

    function saveClosingDay() {
        let tempRestrictions = props.workstation.restrictions.slice()      

        let newClosingDay = { id: generateNewId(tempRestrictions), workstation: 0, start: fromNewDateFormatToYYYYMMDD(start) + " 00:00:00", end: fromNewDateFormatToYYYYMMDD(start) + " 23:59:99", type: 4, addition: description }
        tempRestrictions.push(newClosingDay)

        if (props.checkRestrictionOrderOverlapping(null, null, 0, tempRestrictions, props.order.productionOrders)){
            props.actions.setRestrictions(tempRestrictions)
        }
    }

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>Create closing day</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}><CloseIcon></CloseIcon></Button>
                </div>
            </div>
            <div className={classes.body}>
                <Formik
                    initialValues={
                        { description: "" }}
                    validationSchema={Yup.object().shape({
                        description: Yup.string().required('Description is required'),
                    })}
                >
                    {({ isValid, touched }) => (
                        <Form autoComplete="off" className={classes.form}>
                            <div className={classes.closingDayInfo}>
                                <div className={classes.label}>Closing date</div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker className={classes.datePicker}
                                        autoOk
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd-MM-yyyy"
                                        onChange={date => startDateChanged(date)}
                                        size='small'
                                        value={start}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className={classes.inputAdornment} position="end">
                                                    <IconButton className={classes.iconButton}>
                                                        <img className={classes.calendar} alt="calendar" src={process.env.PUBLIC_URL + '/img/calendar.svg'}></img>
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                                <div className={classes.label}>Description</div>
                                <FormikTextField id="outlined-search" name="description" label="" type="search" variant="outlined" value={""} className={classes.formikTextField} size="small" onChange={(e) => descriptionChanged(e)} />


                            </div>
                            <div className={classes.saveButton}>
                                <GreenButton disabled={!isValid || (Object.entries(touched).length === 0) || start === null} text={"NEW CLOSING DAY"} onClick={saveClosingDay}></GreenButton>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    </Drawer >
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "15px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    drawerOpen: {
        width: "25%",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        float: 'left',
    },
    title: {
        float: 'left',
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px"
    },

    header: {
        width: "100%",
        height: "5%",
        marginBottom: "20px"
    },

    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        marginTop: "10px"
    },
    saveButton: {
        width: "100%",
        textAlign: "center",
        marginTop: "30px"
    },

    datePicker: {
        borderRadius: "6px",
        backgroundColor: "white",
        "& input": {
            fontSize: "14px !important",
            fontFamily: "Lato, sans-serif !important",
        },
        marginBottom: '10px',
        width: "90%"

    },

    formikTextField: {
        width: "100%",
        backgroundColor: "white",
        marginBottom: "10px"
    },

}));